// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"353":"contact","361":"coals","412":"commingsoon","562":"lobster","594":"about","983":"products"}[chunkId] + "." + {"353":"0578ad0c","361":"3da2830b","412":"bead8898","562":"c94dd046","594":"8dbfc5ef","983":"981aae53"}[chunkId] + ".js";
};